import { Doughnut, mixins } from 'vue-chartjs'

export default Doughnut.extend({
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted: function() {
            this.chartOptions = {
                tooltips: {
                    callbacks: {
                        label: function(tooltipItem, data) {
                            return data['labels'][0] + ' ' +data['datasets'][0]['data'][tooltipItem['index']] + '%';
                        },

                    },
                },
                rotation: 1 * Math.PI,
                circumference: 1 * Math.PI,
                responsive: true,
                cutoutPercentage: 92,
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    position: 'bottom',
                }
            };
            this.renderChart(this.chartData, this.chartOptions)
    }
});



// WEBPACK FOOTER //
// ./src/tools/charts/reports/occupancy.js